<script>
export default {
  data: () => {
    return {
      content: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getContent();
    });
  },
  methods: {
    getContent() {
      this.$http
        .get(`/api/v1/globals.json`)
        .then(response => {
          this.content = response.data;
        })
        .catch(error => console.error(error));
    }
  }
};
</script>

<template>
  <div>
    <template v-for="platforms in content">
      <a
        v-for="item in platforms"
        :key="item.name.value"
        :href="item.url"
        target="_blank"
        rel="noopener"
        :title="`Follow us on ${item.name.label}`"
        class="link-item"
      >
        <svg
          v-if="item.name.value === 'x'"
          viewBox="0 0 22 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>X</title>
          <path
            d="m17.2.25h3.31l-7.23 8.26 8.5 11.24h-6.66l-5.21-6.82-5.97 6.82h-3.3l7.73-8.84-8.16-10.66h6.83l4.71 6.23zm-1.16 17.52h1.83l-11.83-15.64h-1.97z"
          />
        </svg>
        <svg
          v-if="item.name.value === 'instagram'"
          viewBox="0 0 19 19"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Instagram</title>
          <path
            d="m9.327 1.658c1.245-.048 2.491-.015 3.731.1.602-.008 1.199.098 1.762.311.776.362 1.4.986 1.762 1.762.214.565.319 1.165.311 1.769 0 .933.1 1.244.1 3.731.048 1.245.015 2.491-.1 3.731.008.602-.098 1.199-.311 1.762-.362.776-.986 1.4-1.762 1.762-.563.213-1.16.319-1.762.311-.933 0-1.244.1-3.731.1-1.245.048-2.491.015-3.731-.1-.602.008-1.199-.098-1.762-.311-.776-.363-1.4-.989-1.761-1.766-.213-.563-.319-1.16-.311-1.762 0-.933-.1-1.244-.1-3.731-.048-1.245-.015-2.491.1-3.731-.008-.602.098-1.199.311-1.762.182-.384.427-.733.727-1.034.243-.362.613-.621 1.036-.725.563-.214 1.162-.32 1.764-.313 1.24-.115 2.486-.148 3.731-.1m-.004-1.662c-1.279-.047-2.559-.013-3.834.1-.779-.002-1.552.139-2.28.415-.629.206-1.199.563-1.658 1.04-.476.46-.832 1.029-1.037 1.658-.327.713-.47 1.497-.418 2.28-.113 1.275-.147 2.555-.1 3.834-.047 1.279-.013 2.56.1 3.835-.002.779.139 1.552.415 2.28.206.629.563 1.199 1.04 1.658.46.475 1.029.831 1.658 1.036.728.276 1.501.417 2.28.415 1.275.113 2.556.147 3.835.1 1.279.047 2.56.013 3.835-.1.779.002 1.552-.139 2.28-.415 1.264-.435 2.26-1.431 2.695-2.695.276-.728.417-1.501.415-2.28 0-1.036.1-1.347.1-3.835.047-1.279.013-2.56-.1-3.835.002-.779-.139-1.552-.415-2.28-.206-.628-.562-1.197-1.038-1.656-.46-.476-1.029-.832-1.658-1.037-.728-.277-1.501-.419-2.28-.418-1.275-.113-2.556-.147-3.835-.1m0 4.56c-.026 0-.051-.001-.077-.001-2.573 0-4.691 2.118-4.691 4.691 0 .026.001.051.001.077 0 2.615 2.152 4.767 4.767 4.767s4.767-2.152 4.767-4.767-2.152-4.767-4.767-4.767m0 7.876c-.018 0-.037.001-.056.001-1.675 0-3.054-1.379-3.054-3.054 0-.019.001-.038.001-.056s-.001-.037-.001-.056c0-1.675 1.379-3.054 3.054-3.054.019 0 .038.001.056.001s.037-.001.056-.001c1.675 0 3.054 1.379 3.054 3.054 0 .019-.001.038-.001.056s.001.037.001.056c0 1.675-1.379 3.054-3.054 3.054-.019 0-.038-.001-.056-.001m4.973-9.223c-.625 0-1.14.515-1.14 1.14s.515 1.14 1.14 1.14 1.14-.515 1.14-1.14c-.005-.623-.517-1.135-1.14-1.14"
          />
        </svg>
        <svg
          v-if="item.name.value === 'linkedin'"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>LinkedIn</title>
          <path
            d="m0 0v24h24v-24zm7.4649 19.9386h-3.56076v-10.71279h3.56076zm-1.78038-12.17494h-.02353c-1.19446 0-1.96868-.82291-1.96868-1.85148 0-1.05115.79685-1.85075 2.01552-1.85075 1.21894 0 1.968.7996 1.99132 1.85075 0 1.02857-.77238 1.85148-2.01463 1.85148zm14.62318 12.17494h-3.5617v-5.7314c0-1.4395-.5146-2.4221-1.8037-2.4221-.9845 0-1.5695.6616-1.8272 1.3024-.0937.229-.1182.5472-.1182.8682v5.9829h-3.56237s.04774-9.7077 0-10.71274h3.56237v1.51804c.4733-.7283 1.318-1.76953 3.21-1.76953 2.3439 0 4.1008 1.53073 4.1008 4.82103z"
          />
        </svg>
        <svg
          v-if="item.name.value === 'bluesky'"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Bluesky</title>
          <path
            d="M110.976 62.336C169.696 106.4 232.832 195.776 256 243.712C279.2 195.776 342.304 106.432 401.024 62.336C443.36 30.56 512 5.95201 512 84.224C512 99.872 503.04 215.584 497.792 234.368C479.488 299.648 412.896 316.32 353.664 306.24C457.216 323.872 483.584 382.24 426.656 440.64C318.624 551.488 271.392 412.8 259.296 377.28C257.056 370.752 256 367.68 256 370.304C256 367.712 254.944 370.752 252.736 377.28C240.608 412.8 193.376 551.488 85.344 440.64C28.448 382.24 54.784 323.84 158.304 306.24C99.104 316.32 32.48 299.68 14.208 234.368C8.96 215.584 0 99.84 0 84.224C0 5.95201 68.64 30.56 110.976 62.336Z"
          />
        </svg>
        <svg
          v-if="item.name.value === 'facebook'"
          viewBox="0 0 10 19"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Facebook</title>
          <path
            d="m6.322 18.655v-8.5h2.9l.415-3.316h-3.315v-2.072c0-.933.311-1.658 1.658-1.658h1.762v-3.009c-.415 0-1.451-.1-2.591-.1-.089-.006-.178-.009-.267-.009-2.195 0-4 1.806-4 4 0 .121.005.242.016.362v2.487h-2.9v3.316h2.9v8.5z"
          />
        </svg>
      </a>
    </template>
  </div>
</template>

<style lang="postcss" scoped>
.link-item {
  @apply flex;
  width: 20px;
  height: 20px;
  fill: currentColor;
}
</style>
